import { TweenLite } from "gsap";
import * as HLF from "html-living-framework";
import * as AssetHelpers from "../core/AssetHelpers";
import {HoverableButton, TextureButton} from "../core/Button";
import {Callback, Mix} from "../core/Reflection";
import { Sprite } from "../core/Sprite";
import {TransformBackup} from "../core/TransformBackup";
import { LightsOutObjectType } from "../data/LightsOutObjectType";
import {TrashType} from "../data/TrashType";
import { GlowFilter } from "../filters/GlowFilter";
import { OutlineFilter } from "../filters/OutlineFilter";
import { AudioChannel } from "../managers/AudioChannel";
import { Button } from "./Button";

export class TrashBlastEasterEgg extends Button {

    public get hoverDisabled() {return !this.clickable; }
    public get downDisabled() {return !this.clickable; }
    public hoverSFX?: string;

    public clickable: boolean = true;
    public turnedOff: boolean = false;
    protected outlineFilter: PIXI.Filter;
    protected onSprite = this.visuals.addChild(new HLF.AnimatedSprite());
    protected spriteSheet: string | string[];
    protected frameCount: number;
    protected splitFrame?: number;
    protected loopCount: number;

    constructor(pData: {
        spriteSheet: string | string[],
        frames: number,
        splitFrame?: number,
        toggle?: boolean,
        loopCount?: number,
    }) {
        super();
        // this.clickable = pClickable;
        this.outlineFilter = new OutlineFilter(5, 0xffff00);
        this.outlineFilter.enabled = false;
        this.visuals.filters = [this.outlineFilter];
        this.onDown.add(() => {
            PubSub.publishSync("item clicked", this);
        });

        this.onOver.add(() => {
            if (this.hoverSFX && !this.turnedOff) {
                AudioChannel.SFX.play(this.hoverSFX, "loop");
            }
        });

        this.onOut.add(() => {
            if (this.hoverSFX) {
                AudioChannel.SFX.stop(this.hoverSFX);
            }
        });

        this.spriteSheet = pData.spriteSheet;
        this.frameCount = pData.frames;
        this.splitFrame = pData.splitFrame;
        this.toggle = pData.toggle ?? false;
        if (pData.loopCount === undefined) {
            this.loopCount = 1;
        }
        else {
            this.loopCount = pData.loopCount;
        }
        this.update = this.update.bind(this);
        PIXI.Ticker.shared.add(this.update);
    }
    public onLayout() {
        this.scale.set(Math.max(this.scale.x, this.scale.y));
        const onAnimStartFrame = 1;
        const onAnimFrameCount = this.splitFrame ?? this.frameCount;
        const fps = 10;
        const loop: boolean = this.loopCount !== 0 && this.loopCount !== 1;
        const anim = new HLF.SpriteAnimation(this.name + "-on", this.spriteSheet, onAnimFrameCount, 2, fps, loop, onAnimStartFrame);
        let c = 0;
        if (loop) {
            anim.onLoop(() => {
                c++;
                if (c < this.loopCount) {
                    //
                }
                else if (c === this.loopCount) {
                    // done looping
                    this.onSprite.holdFrame("on", onAnimFrameCount);
                    if (!this.toggle) {
                        c = 0;
                        this.TurnOff();
                    }
                }
            });
        }

        anim.onComplete(() => {
            if (!this.toggle) {
                this.TurnOff();
            }
        });
        this.onSprite.addAnimation("on", anim);

        if (this.splitFrame) {
            const offAnimStartFrame = this.splitFrame;
            const offAnimFrameCount = (this.frameCount - this.splitFrame) + 1;
            const anim2 = new HLF.SpriteAnimation(this.name + "-on", this.spriteSheet, offAnimFrameCount, 2, fps, false, offAnimStartFrame);
            anim2.onComplete(() => {
                TweenLite.delayedCall(1 / fps, () => {
                    this.onSprite.visible = false;
                    this.sprite.visible = true;
                });
            });
            this.onSprite.addAnimation("off", anim2);
        }
    }

    public TurnOn(): void {
        this.sprite.visible = false;
        this.onSprite.play("on");
        this.onSprite.update(0);
        this.onSprite.visible = true;
        PubSub.publishSync("item turned on", this);
        // this.enabled = true;
        this.turnedOff = false;
    }

    public TurnOff(pOptions?: {animate: boolean}): void {
        if (this.splitFrame) {
            this.onSprite.play("off");
        }
        else {
            this.onSprite.visible = false;
            this.sprite.visible = true;
        }
        // this.enabled = false;
        this.clickable = false;
        this.turnedOff = true;
        PubSub.publishSync("item turned off", this);
        this.UnHighlight();
        if (this.hoverSFX) {
            AudioChannel.SFX.stop(this.hoverSFX);
        }
    }

    public Highlight() {
        this.outlineFilter.enabled = true;
    }

    public UnHighlight() {
        this.outlineFilter.enabled = false;
    }
    public destroy() {
        super.destroy();
        PIXI.Ticker.shared.remove(this.update);
    }

    public setLayoutTexture(texture: string | PIXI.Texture, anchorX: number, anchorY: number) {
        super.setLayoutTexture(texture, anchorX, anchorY);
        this.onSprite?.anchor.set(anchorX, anchorY);
    }
    protected update() {
        const deltaTime: number = PIXI.Ticker.shared.deltaMS / 1000;
        this.onSprite.update(deltaTime);
    }
}
